// Tweaks panel — accent color only
import { type ReactNode } from "react";
import { Icon } from "./Pieces";

export type TweakValues = { accent: string };

export function Tweaks({
  open,
  values,
  onChange,
}: {
  open: boolean;
  values: TweakValues;
  onChange: (next: TweakValues) => void;
}) {
  if (!open) return null;
  const swatches: [string, string][] = [
    ["#ED8B5A", "Terracotta"],
    ["#4ECDC4", "Teal"],
    ["#5B9BD5", "Blue"],
  ];
  return (
    <div className="tweaks-panel">
      <div className="tweaks-head">
        <Icon name="tune" size={16} />
        <strong>Tweaks</strong>
      </div>
      <TwRow label="Accent">
        {swatches.map(([hex, l]) => (
          <button
            key={hex}
            className={`tw-opt sw ${values.accent === hex ? "on" : ""}`}
            onClick={() => onChange({ ...values, accent: hex })}
            title={l}
          >
            <span style={{ background: hex }} /> {l}
          </button>
        ))}
      </TwRow>
    </div>
  );
}

function TwRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="tw-row">
      <div className="tw-label">{label}</div>
      <div className="tw-opts">{children}</div>
    </div>
  );
}
